import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useAuthentication } from '@hooks/useAuthentication'
import { useCategories } from '@hooks/useCategories'
import { BookEnum } from '@interfaces/BookEnum'
import { TimeRangeEnum } from '@interfaces/TimeRangeEnum'
import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import {
  SearchSaleAnalyticsProps,
  SearchSaleAnalyticsAcceptProps,
} from './interfaces'

const bookType = [
  { value: BookEnum.NOVEL, label: 'นิยาย' },
  { value: BookEnum.MANGA, label: 'การ์ตูน' },
]

export const timeRangeOption = [
  { value: TimeRangeEnum.DAY, text: 'วันนี้' },
  { value: TimeRangeEnum.WEEK, text: '7 วัน' },
  { value: TimeRangeEnum.MONTH, text: '30 วัน' },
  { value: TimeRangeEnum.THREE_MONTH, text: '3 เดือน' },
  { value: TimeRangeEnum.SIX_MONTH, text: '6 เดือน' },
  { value: TimeRangeEnum.YEAR, text: '1 ปี' },
]

export function withSearchSaleAnalytics(
  Component: React.FC<SearchSaleAnalyticsProps>
) {
  function WithSearchSaleAnalytics(props: SearchSaleAnalyticsAcceptProps) {
    const router = useRouter()
    const penNameClient = usePenNameAction()
    const { user } = useAuthentication()
    const { data: penNameOptions = [] } = useQuery(
      ['pen-name-options', user?.id],
      () =>
        penNameClient.getPenNameOptions(user?.id).then(res =>
          res.map(row => ({
            ...row,
            value: String(row.value),
          }))
        ),
      { enabled: !!user.id }
    )

    const { categories } = useCategories()
    const [advanceSearch, setAdvanceSearch] = useState<boolean>(
      router.query.advanceSearch === 'true'
    )

    useEffect(() => {
      if (router.query.advanceSearch) {
        setAdvanceSearch(router.query.advanceSearch === 'true')
      }
    }, [router.query.advanceSearch])

    function handleAdvanceSearchChange() {
      setAdvanceSearch((prev: boolean) => !prev)

      router.replace(
        {
          pathname: router.pathname,
          query: {
            tab: 'salesAnalytics',
            advanceSearch: !advanceSearch,
            ...(router.query.bookId && { bookId: router.query.bookId }),
            ...(router.query.subtab && { subtab: router.query.subtab }),
          },
        },
        undefined,
        { scroll: false }
      )
    }

    const pageProps = {
      ...props,
      bookType,
      categories,
      penNameOptions,
      advanceSearch,
      handleAdvanceSearchChange,
    }
    return <Component {...pageProps} />
  }

  return WithSearchSaleAnalytics
}
